// @flow

export { default } from './Avatar';
